import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import AuthService from './services/auth.service'
import VueCookie from 'vue-cookie'
import Datetime from 'vue-datetime'
import VueGtag from "vue-gtag";
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueForceNextTick from "vue-force-next-tick";
import Vuelidate from 'vuelidate'
import store from './store'
import axios from 'axios'

// note: this 'if' prevents an error from MSAL
// see: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-avoid-page-reloads
// see: https://stackoverflow.com/questions/59931529/clientautherror-token-calls-are-blocked-in-hidden-iframes#comment106014189_59931529
if (window.self === window.top) {
  Vue.use(BootstrapVue);
  Vue.use(BootstrapVueIcons);
  Vue.use(VueCookie);

  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GOOGLE_KEY }
  }, router);

  Vue.use(Datetime)
  Vue.use(VueForceNextTick)
  Vue.use(Vuelidate)

  Vue.config.productionTip = false
  Vue.config.errorHandler = (err, vm, info) => {
    console.log("--------- ERROR HANDLER ---------")
    console.log(err)
    console.log(vm)
    console.log(info)
    console.log("---------------------------------")
  }

  let authService = new AuthService()
  store.$auth = authService

  Vue.prototype.$AuthService = authService
  Vue.prototype.$eventBus = new Vue()
  
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  });
}
